function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2163 23.86C31.6062 21.7814 33.8354 18.6685 35.3767 17.6074",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4207 21.4485C78.4207 21.4485 69.7751 28.5818 66.8319 29.6792C66.8319 29.6792 60.2097 21.2656 28.9382 25.8382C28.9382 25.8382 29.4495 25.0063 30.2158 23.8601L19.3715 27.8071C19.3715 27.8071 19.005 21.2656 30.2259 16.693C39.198 13.0368 47.3466 12.7718 53.5439 15.524C55.0973 16.2136 56.528 17.0929 57.8184 18.1562C64.2566 23.4604 71.9825 20.534 74.5578 17.7904C74.5578 17.7904 75.6615 20.8998 78.4207 21.4485Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2162 23.8601C29.4498 25.0063 28.9386 25.8382 28.9386 25.8382C28.9386 25.8382 26.548 29.0212 23.4353 34.5075L6.72335 40.0494C4.19083 37.0674 4.91109 33.0701 4.91109 33.0701L19.3718 27.807L30.2162 23.8601Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.72318 40.0494L3.61455 41.0802C0.0581815 39.3731 1.16188 34.4347 1.16188 34.4347L4.91092 33.0701C4.91092 33.0701 4.19066 37.0674 6.72318 40.0494Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M77.6851 44.1287C77.4524 44.1108 77.2183 44.1203 76.9845 44.1533C75.0046 44.4316 73.0335 46.3861 71.9388 47.6591C71.3995 48.2861 71.0733 48.7476 71.0632 48.762C71.0629 48.7622 71.0629 48.7622 71.0629 48.7622C60.8844 29.8622 33.6188 41.69 33.6188 41.69C22.8271 53.8835 20.865 81.6849 20.865 81.6849C20.2591 81.1327 19.4143 80.8078 18.4545 80.6403C16.3436 80.2713 13.6764 80.6625 11.7734 81.0671C10.3381 81.3722 9.3374 81.6849 9.3374 81.6849C9.81131 61.8955 17.8043 44.4327 23.4351 34.5077C26.5478 29.0214 28.9383 25.8383 28.9383 25.8383C60.2099 21.2657 66.8321 29.6793 66.8321 29.6793C73.4082 34.7548 77.6851 44.1287 77.6851 44.1287Z",
  fill: "white",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1659 16.2969C82.5601 17.9428 78.421 21.4486 78.421 21.4486C75.6618 20.8998 74.5581 17.7905 74.5581 17.7905C74.5581 17.7905 77.1947 16.2053 77.6853 14.6201C78.1758 13.035 80.5058 11.5108 79.7087 14.8944C79.7087 14.8944 78.9729 17.1808 81.5174 15.626C83.0228 14.7063 84.9356 14.5334 85.7076 14.8862C86.241 15.1298 86.2303 15.6244 85.1659 16.2969Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7411 13.9495L85.7075 14.8862C84.9355 14.5334 83.0227 14.7063 81.5173 15.626C78.9728 17.1808 79.7086 14.8943 79.7086 14.8943C80.5057 11.5108 78.1756 13.035 77.6851 14.6201C77.1946 16.2053 74.5579 17.7905 74.5579 17.7905C71.9826 20.534 64.2567 23.4605 57.8184 18.1563C56.528 17.093 55.0973 16.2137 53.5439 15.5241L84.7366 4.37754C84.7366 4.37754 84.8878 4.31792 85.1244 4.29868H85.1246C85.2898 4.28514 85.4972 4.29164 85.7236 4.35179L85.7242 4.35206C86.8764 4.65907 88.5292 6.36102 87.7411 13.9495Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M87.741 13.9495C88.5292 6.36101 86.8763 4.65906 85.7241 4.35205L96.9999 5.35301L87.741 13.9495Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.3102 8.82818C53.3102 11.2525 51.3336 13.2179 48.8953 13.2179C46.4571 13.2179 44.4805 11.2525 44.4805 8.82818C44.4805 8.08411 44.6666 7.38338 44.9953 6.76937C45.5114 5.80473 46.3791 5.05415 47.4283 4.68671C47.8873 4.52603 48.3811 4.43851 48.8953 4.43851C51.3336 4.43851 53.3102 6.40384 53.3102 8.82818Z",
  fill: "white",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M47.5683 3.7778C47.5683 4.09429 47.5195 4.39968 47.4288 4.68663C46.3796 5.05406 45.5119 5.80465 44.9957 6.7693C44.8417 6.79314 44.6839 6.8056 44.5232 6.8056C42.8412 6.8056 41.478 5.44995 41.478 3.7778C41.478 2.10538 42.8412 0.75 44.5232 0.75C46.2049 0.75 47.5683 2.10538 47.5683 3.7778Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4545 80.6401V84.4711C16.2493 85.191 13.3143 84.4583 11.7734 83.9633V81.0669C13.6764 80.6624 16.3436 80.2711 18.4545 80.6401Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M26.455 94.3813L11.0953 95.25C11.0953 95.25 6.08261 95.0216 9.80768 91.5006C9.80768 91.5006 13.9132 92.3046 19.3464 92.4609C22.4354 92.5498 25.5056 92.8571 28.9423 91.8128C29.2789 93.2326 26.455 94.3813 26.455 94.3813Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9422 91.8129C25.5054 92.8572 22.4352 92.5499 19.3462 92.4611C13.913 92.3047 9.80753 91.5007 9.80753 91.5007C9.80753 91.5007 9.68108 84.8704 10.7273 83.59C10.7273 83.59 11.1282 83.7558 11.7735 83.9634C13.3143 84.4585 16.2493 85.1912 18.4546 84.4712C19.1454 84.246 19.7643 83.8781 20.2466 83.3158C20.2466 83.3158 23.0519 88.2998 27.2828 90.312C28.3527 90.8206 28.8285 91.3325 28.9422 91.8129Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0411 47.0345C77.6638 48.686 75.1144 49.6686 73.6907 50.1135L72.2867 48.1463L71.939 47.6591C73.0337 46.386 75.0048 44.4315 76.9846 44.1532L77.2395 44.5103L79.0411 47.0345Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M91.5462 46.7695C89.4357 49.4898 86.8563 50.9473 84.384 52.5869C80.0362 55.4706 76.3673 57.1116 76.3673 57.1116C76.3673 57.1116 72.5577 51.9824 72.6613 50.3997C72.6613 50.3997 73.0684 50.3078 73.6906 50.1135C75.1142 49.6686 77.6636 48.6861 79.041 47.0345C79.5509 46.4227 79.9002 45.7195 79.9725 44.9177C79.9725 44.9177 84.9612 47.2738 89.4049 46.5105C90.5286 46.3175 91.1881 46.4555 91.5462 46.7695Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M91.0332 50.1596L79.4752 59.3393C79.4752 59.3393 75.4169 61.9333 76.3674 57.1117C76.3674 57.1117 80.0363 55.4707 84.384 52.587C86.8563 50.9474 89.4357 49.4898 91.546 46.7695C92.6048 47.6965 91.0332 50.1596 91.0332 50.1596Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7734 81.067V82.1122L9.33876 81.6854L9.3374 81.6851C9.3374 81.6851 10.3381 81.3723 11.7734 81.067Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M20.865 81.685C20.865 81.685 18.8546 82.2194 18.4546 82.1121V80.6403C19.4144 80.8078 20.2592 81.1327 20.865 81.685Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M72.2863 48.1465C71.7912 48.4792 71.0799 48.756 71.063 48.7625C71.0731 48.7481 71.3993 48.2864 71.9386 47.659L72.2863 48.1465Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0633 48.7618C71.063 48.7621 71.063 48.7621 71.063 48.7621",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M77.685 44.1286C77.685 44.1286 77.4602 44.2978 77.2392 44.5106L76.9844 44.1533C77.2182 44.1202 77.4523 44.1107 77.685 44.1286Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

function SvgIllustrationDrawing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDrawing);
export default __webpack_public_path__ + "static/media/illustration-drawing.941de6e8.svg";
export { ForwardRef as ReactComponent };